import { Component } from "@angular/core";
import { PropertiesSettings as ps } from "../../../core/configuration/properties-settings";
import { PetitumRevisione } from "../../models/petitum-revisione";
import { UtilityCommon } from "../../utils/utility-common";


declare var openModal: any;
@Component({
    selector: 'div [valore-economico-revisione-list]',
  templateUrl: 'valore-economico-revisione-list.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'', '[attr.id]': '\'valoreEconomicoRevisioneList\'' }
})

export class ValoreEconomicoRevisioneListComponent {
  idPetitumQuantificabile = ps.ID_TIPO_PETITUM_QUANTIFICABILE;
  recuperoCrediti: boolean;
  lastRevisione: number = 0;
  petitumRevisioniList: PetitumRevisione[] = [];
  calcolaSomma = UtilityCommon.calcolaSomma;

  inizializza(petitumRevisioniList: PetitumRevisione[], recuperoCrediti: boolean) {
    this.recuperoCrediti = recuperoCrediti;
    if (petitumRevisioniList.length > 0) {
      openModal('valoreEconomicoRevisioneList');
      this.petitumRevisioniList = petitumRevisioniList;
      this.lastRevisione = 0;
    }
  }
}
